<template>
  <div>
    <div class="right-title">
      <span>表单详情</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="search-box">
        <el-input
          class="search"
          type="text"
          placeholder="请输入职位ID/名称"
          v-model="search"
        >
        </el-input>
        <el-button class="btn2" @click="keyWord" type="primary">搜索</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',color: '#000;'}"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="id"
            label="ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="jobs_name"
            label="职位标题"
            align="center"
          >
            <template slot-scope="scope">
              <span style="color: #00a2ea;cursor: pointer;"
                    @click="toDetail(scope.row.id)">{{scope.row.jobs_name}}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--                  prop="name"-->
          <!--                  label="职位类型"-->
          <!--                  align="center"-->
          <!--          >-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="organization_name"
            label="所在机构"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="cursor: pointer;"
                    @click="toOrg(scope.row.organization_id)">{{scope.row.organization_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="发布时间"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.create_time}}</span>
            </template>
          </el-table-column>

        </el-table>
        <div class="page-box">
          <div>
            <el-button type="danger" @click="deleteList">删除</el-button>
          </div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>

    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "zwList",
    data() {
      return {
        search: '',  // 搜索
        tableData: [],
        multipleSelection: [], //  选中的
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },

    },
    created() {
      this.$emit('setType', 1)
      this.wzList()
    },
    methods: {
      // 职位列表
      wzList() {
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        this.$api.apiContent.hjFormD({
          search: this.search,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          admin_id: this.user.id,
          id: this.$route.params.id,
          type:3
        }).then(res => {
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          res.data.map(item => {
            item.create_time = this.$tools.ZHDate(new Date(item.create_time * 1000), 1)
          })
          this.tableData = res.data
        }).catch(() => {
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      keyWord() {     //  搜索
        if(this.page.pageNum === 1){
          this.setPath()
        }else{
          this.page.pageNum = 1
        }
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },
      //  去机构详情
      toOrg(id){
        this.$router.push('/home/jgAdmin/jgDetail/' + id)
      },
      toDetail(id){
        this.$router.push('/home/zwAdmin/zwDetail/' + id)
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/zwAdmin/zwBiaoDanDetail/' + this.$route.params.id,
          query: {
            pageNum: this.page.pageNum,
            key: this.search
          }
        })
      },
      //  列表选中存入数据
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //  删除选中的
      deleteList() {
        console.log(this.multipleSelection)
        if (this.multipleSelection.length > 0) {
          let len = this.multipleSelection.length
          this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let _arr = []
            this.multipleSelection.map(item => {
              _arr.push(item.id)
            })
            this.$api.apiContent.formItemDel({
              id: _arr.join(","),
              type:3,
              form_id:this.$route.params.id,
              admin_id: this.user.id
            }).then(res => {
              if (this.page.pageNum > 1 && len === this.list.length) {
                this.page.pageNum = this.page.pageNum - 1
              } else {
                this.wzList()
              }
              this.$message({
                type: 'success',
                message: res.info
              });
              this.$refs.multipleTable.clearSelection();
            }).catch(res => {
              this.$message.error(res.info);
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          this.$message.error("请选中要删除的数据！");
        }
      },
      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.wzList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;


    .search {
      width: 220px;
      position: absolute;
      right: 80px;
      border-radius: 4px !important;
    }

    .btn {
      position: absolute;
      left: 0px;
      padding: 10px 40px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>